import { jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-cards.css';
import { EGDSCardTags, EGDSCardContentSectionBorders, EGDSCardContentSectionPaddings } from '../types/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSCardContentSection = props => {
  const {
    border,
    children,
    className,
    padded = true,
    tag,
    useStandardCardPadding,
    ...attributes
  } = props;
  let link;
  const newChildren = [];
  const Tag = tag && EGDSCardTags.get(tag) || EGDSCardTags.get('div');
  // Map through the children and place the ones we want in specific places
  React.Children.forEach(children, child => {
    if (!child) {
      return;
    }
    if (child.type.displayName?.match(/(EGDS|Uitk)CardLink/)) {
      link = child;
    } else {
      newChildren.push(child);
    }
  });
  const paddedClass = (prop, paddedBaseClass) => {
    const propType = typeof prop;
    const classStr = [];
    const uiStandardPaddingClassPrefix = useStandardCardPadding ? '-standard' : '';
    if (propType === 'boolean') {
      classStr.push(`${paddedBaseClass}${uiStandardPaddingClassPrefix}-padded`);
    } else {
      prop && prop.forEach(value => classStr.push(`${paddedBaseClass}${uiStandardPaddingClassPrefix}-padded-${EGDSCardContentSectionPaddings.get(value)}`));
    }
    return classStr.join(' ');
  };
  const baseClass = 'uitk-card-content-section';
  const cssClassNames = getClassNameList(baseClass, border && `${baseClass}-border-${EGDSCardContentSectionBorders.get(border)}`, link && `${baseClass}-has-link`, padded && paddedClass(padded, baseClass), className);
  return jsxs(Tag, {
    className: cssClassNames,
    ...attributes,
    children: [newChildren, link]
  });
};
EGDSCardContentSection.displayName = 'EGDSCardContentSection';
// Temporary, unstable
const EGDSCardAlohaContentSection = EGDSCardContentSection;
export { EGDSCardAlohaContentSection, EGDSCardContentSection };